import list from './list'
import edit from './edit'
import create from './create'
import icon from '@material-ui/icons/Person'

const countries = { list, edit, create, icon, options: { label: 'Countries' } }

export default countries
